<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>

            <step-container
                :current_step="1"
                :step_list="stepList"
            ></step-container>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <CompanyInfo
                                class="p-3"
                                ref="companyInfo"
                                :information = information
                                :account_id = account_id
                                :user_no = user_no
                                @on-error = "onError"
                                @file-uploaded = "fileUploaded">   
                            </CompanyInfo>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <button @click="nextStep" class="ml-auto btn btn-primary d-block">{{ $t('Next Step') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import CompanyInfo from '@/components/CardManagement/companyInfo';
    import CreateAccount from '@/services/CreateAccount';
    import Account from "@/services/Account";
  
    export default {
        name: 'international-company-information',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                account_id : '',
                user_no : '',
                information : '',
                stepList:["Company Info","Business Address", "Registered Address", "Director Info","Beneficiary Info"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            CompanyInfo
        },
        methods:{
            nextStep(){
                this.isLoading = true;
                if(this.$refs['companyInfo'].validate()){
                    if(this.user_no){
                        this.$refs['companyInfo'].uploadFile(this.account_id,this.user_no);
                    }
                    else{
                        CreateAccount.createType({"userType":5}).then(response => {
                            const data = response.data.data;
                            this.user_no = data['userNo'];
                            this.account_id = data['accountId'];
                            this.$refs['companyInfo'].uploadFile(data['accountId'],data['userNo']);
                        }).catch(err => {
                            this.checkError(err);
                        });
                    }
                }
                else{
                    this.isLoading = false;
                }
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let companyInfo = this.$refs['companyInfo'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    if(typeof companyInfo.error[key] !== "undefined"){
                                        companyInfo.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            onError(){
                this.isLoading = false;
            },
            fileUploaded(){
                
                let companyInfo = this.$refs['companyInfo'];

                let params = {
                    "accountId":this.account_id,
                    "userNo":""+this.user_no,
                    "name":companyInfo.params.name,
                    "enName":companyInfo.params.enName,
                    "orgRegister":companyInfo.file.orgRegister,
                    "orgRegisterNo":companyInfo.params.orgRegisterNo,
                    "registerDate":companyInfo.params.registerDate,
                    "registerAmt":parseFloat(companyInfo.params.registerAmt),
                    "otherAccessories":companyInfo.file.otherAccessories
                }
                Account.updateInternational(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$router.push({ 
                        name: 'international-business-address'
                    });
                }).catch(err => {
                    this.checkError(err);
                });
            }
        },
        mounted() {
            this.init = false;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        if(response.data.data.length>0){
                            this.account_id = response.data.data[0]['id'];
                            this.user_no = response.data.data[0]['userNo'];
                            this.information = response.data.data[0]['information'];
                        }
                        this.init = true;
                    }
                });
            });
        },
    };
  </script>